import {
  COMMISSION_FIXED_FEE_CENTS,
  COMMISSION_MIN_FEE_CENTS,
  COMMISSION_RATE_BPS,
} from "../constants/api.constants.js";

/**
 * Commission BoulesConnect par inscription (cents TTC).
 *
 * Formule : `max(plancher ; round(prix × bps / 10 000) + part fixe)`.
 * - `prix <= 0` (concours gratuit) → 0.
 * - Plancher 0,75 € / part fixe 0,30 € / taux 2 % (cf. api.constants.ts).
 *
 * Bascule de régime à 22,50 €/équipe : en dessous le plancher domine,
 * au-dessus c'est `2 % + 0,30 €`. Taux effectif strictement décroissant.
 *
 * UNIQUE SOURCE DE VÉRITÉ — ne PAS ré-implémenter ailleurs (API checkout,
 * seed, admin estimation, front). Toute duplication = dérive et
 * `[CHECKOUT_FEE_MISMATCH]` en boucle.
 */
export function computeCommissionCents(priceCents: number): number {
  if (priceCents <= 0) return 0;
  return Math.max(
    COMMISSION_MIN_FEE_CENTS,
    Math.round((priceCents * COMMISSION_RATE_BPS) / 10_000) +
      COMMISSION_FIXED_FEE_CENTS,
  );
}
